
import {Component, Vue} from "vue-property-decorator";
import ContentPageLayout from "@/components/UI/renewal/ContentPageLayout.vue";
import AccessContent from "@/components/access/AccessContent.vue";

@Component({
  components: {
    ContentPageLayout,
    AccessContent,
  },
})
export default class Access extends Vue {
}
